import React from 'react';
import { Modal, ModalOverlay, Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { spinnerBeat } from '@laliga-cdac/assets';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject;

var breatheAnimation = /*#__PURE__*/keyframes(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n 0% { background-position: 0px 0px; }\n 100% { background-position: 0px -1800px; }\n"])));

var BeatSpinner = function BeatSpinner(props) {
  var isOpen = props.isOpen;
  return React.createElement(Modal, {
    isOpen: isOpen,
    onClose: function onClose() {
      return null;
    }
  }, React.createElement(ModalOverlay, null), React.createElement(Box, {
    __css: {
      position: 'fixed',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: '150px',
      height: '150px',
      animation: breatheAnimation + " 1.2s steps(12) 0s infinite",
      background: "url(" + spinnerBeat + ")",
      zIndex: 'popover'
    }
  }));
};

export default BeatSpinner;